import styled from 'styled-components';
import { Body } from 'components/Typography';
import AddButton from 'components/Buttons/AddButton';
import Placeholder from 'components/Placeholders/BasicPlaceholder';
import addAlpha from 'utils/addAlpha';
import NoMenuIcon from 'assets/icons/no-menu.svg?react';

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const Container = styled(Placeholder)``;

// TODO: TFR-45:Icon make unique name or do not export
export const Icon = styled(NoMenuIcon)`
  margin-bottom: 1.875rem;
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.2)};
`;

// TODO: TFR-45:Title make unique name or do not export
export const Title = styled(Body)`
  font-weight: 600;
  margin-bottom: 1.5625rem;
`;

// TODO: TFR-44 move to typography group
export const Subtitle = styled(Body)`
  margin-bottom: 1.625rem;
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const Button = styled(AddButton)``;
